import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { httpClientCoreQuery } from '@/api/http-client';

export function deleteTopicsBulk(ids: number[]) {
    const q = new CoreQuery().entity([EntitiesList.TOPICS, EntitiesList.PERSONA, EntitiesList.TOPIC]).data(ids);

    return httpClientCoreQuery.delete(q);
}
